<!-- =========================================================================================
  File Name: EditVideoSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer index v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>EDIT INCIDENT VIDEO</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">

        <div class="slot-fields">

          <div class="contained-example-container" :style="{ opacity: opacity}"  id="div-video" >
            <div  id="div-with" class="vs-con-loading__container" ref="div-with">
              <br>
              <div>
                <span style="font-weight: bold"> Video:</span>
              <div  class="img-container w-64 mx-auto flex items-center justify-center">
                <video width="250" controls :src="dataVideo"></video>
              </div>
            </div>
          </div>
          </div>
          <div class="modify-img flex justify-between mt-5">
            <!--            <input type="file" ref="updateImgInput" @change="uploadVideo($event)" accept="video/*">-->

            <input type="file" ref="file" @change="uploadFile()" accept="video/*">

          </div>
          <br>
          <label class="vs-select--label w-full ">Date & Time *</label>
            <vs-row class="mb-5">
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
              <datepicker class="w-full" v-model="dataDate" format="MM/dd/yyyy" :minimumView="'day'"
                       placeholder="Date"    :maximumView="'year'" :initialView="'month'"></datepicker>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="end" vs-align="center" vs-w="4">
            <flat-pickr  class="mypicker" v-model="dataEndTime" :config="configdateTimePicker" name="start_time" placeholder="Start time"/>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="4">
            <flat-pickr class="mypicker" v-model="dataEndTime" :config="configdateTimePicker" name="end_time" placeholder="End time"/>
            </vs-col>
            </vs-row>
          <label class="vs-select--label w-full">Camera</label>
          <v-select label="name" :closeOnSelect="true" v-model="dataCamera" :options="cameras"/>
        </div>
       </div>
    </component>
      <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {GET_CAMERA_BY_LOCATION, UPDATE_SINGLE_INCIDENT_VIDEO, UPLOAD_VIDEO} from '@/graphql'
import S3 from 'aws-s3';

const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: process.env.VUE_APP_AWS_DIREC,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config);

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    flatPickr,
    moment
  },
  data() {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      opacity:1,
      dataId:null,
      dataVideo:'',
      dataFileName:'',
      dataOriginalName:'',
      dataDate:'',
      dataStartTime:'',
      dataEndTime:'',
      dataCamera:'',
      cameras:[],
      checkvideo:true,

    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id,video,file_name,original_name,date,start_time,end_time,camera,location} = JSON.parse(JSON.stringify(this.data))
        this.getcamera(location)
        this.dataId = id
        this.dataVideo=video
        this.dataFileName=file_name
        this.dataOriginalName=original_name
        this.dataStartTime=start_time
        this.dataEndTime=end_time
        this.dataDate=date
        this.dataCamera=camera
        // this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.dataDate && this.dataStartTime && this.dataEndTime && this.dataVideo && this.dataCamera.id && this.checkvideo
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }

  },
  methods: {
    uploadFile() {
        let file = this.$refs.file.files[0];
        let orignal_name = this.$refs.file.files[0].name
        let name = Math.random().toString().slice(2)
        this.openLoadingInDiv();
        S3Client
          .uploadFile(file, name)
          .then(response => {
            // console.log(response)
            this.$vs.loading.close(`#div-with > .con-vs-loading`)
            document.querySelector('#div-video').style.opacity = 1;
            this.dataVideo = response.location
            this.dataOriginalName =orignal_name
            this.dataFileName =response.key

            // this.SaveFile(response, orignal_name)
          })
          .catch(error => {
            console.log(error)
            this.$vs.loading.close('#div-with > .con-vs-loading')
            document.querySelector('#div-video').style.opacity = 1;
          });

    },

    openLoadingInDiv() {
      document.querySelector('#div-video').style.opacity = 0.2;
      this.$vs.loading({
        type: 'sound',
        container: '#div-with',
        scale: 0.6
      })
    },
    uploadVideo(input) {
      var oldvideo = ''
      if (input.target.files && input.target.files[0]) {
        let limit = 1024 * 1024 * 20;
          if(input.target.files[0].size > limit){
            this.sizemessage()
            return false
          }
        const reader = new FileReader()
        reader.onload = e => {
          this.dataVideo = e.target.result
          this.openLoadingInDiv()
          this.checkvideo=false
          this.$apollo
            .mutate({
              mutation: UPLOAD_VIDEO,
              variables: {
                video: this.dataVideo,
                oldvideo:oldvideo,
              }
            })
            .then(response => {
              if (response) {
                this.oldvideo = ''
                if (response.data.uploadVideo.status == "SUCCESS") {
                  this.dataVideo = response.data.uploadVideo.video_name
                  this.$vs.loading.close(`#div-with > .con-vs-loading`)
                  document.querySelector('#div-video').style.opacity = 1;

                  this.checkvideo=true
                }
              }
            }).catch(error => {
            console.log(error)
            this.$vs.loading.close('#div-with > .con-vs-loading')
            document.querySelector('#div-video').style.opacity = 1;
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    StatusSuccess() {
      this.$emit('getdata',true)
      this.$vs.notify({
        title: "Incident",
        text: 'Incident Update Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
      getcamera(location){
     this.$apollo
        .mutate({
          mutation: GET_CAMERA_BY_LOCATION,
          variables: {
            location_id: location
          }
        })
       .then(response => {
         if (response) {
           this.cameras = response.data.location_cameras
         }
       }).catch(error => {
       console.log(error)
     });
      },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataDate) {
            this.dataDate = moment(String(this.dataDate)).format('MM/DD/YYYY')
          }
          if (this.dataVideo == '') {
            this.$vs.notify({
              title: "Incident",
              text: 'Incident Video is Required!',
                  color: 'danger',
                  position: 'top-right'
            })
            }
            this.$apollo
              .mutate({
                mutation: UPDATE_SINGLE_INCIDENT_VIDEO,
                variables: {
                  id:this.dataId,
                  date:this.dataDate,
                  start_time:this.dataStartTime,
                  end_time:this.dataEndTime ,
                  camera:this.dataCamera.id,
                  video: this.dataVideo,
                  original_name: this.dataOriginalName,
                  file_name: this.dataFileName
                }
              })
              .then(response => {
                if (response.data.updateSingleIncidentVideo.status=='SUCCESS') {
                  this.StatusSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()

                }
              }).catch(error => {
              console.log(error)
            })
        }
      })
    },
    failedmessage(){
        this.$vs.notify({
        title: "Incident",
        text: 'Incident Video is Required!',
        color: 'danger',
        position: 'top-right'
      })
    },
     sizemessage(){
        this.$vs.notify({
        title: "Incident",
        text: 'Video is too Large!',
        color: 'danger',
          position: 'top-right'
        })
     },
    initValues() {
      this.dataId = null
      this.dataVideo = ''
      this.dataFileName = ''
      this.dataOriginalName = ''
      this.dataDate = ''
      this.dataStartTime = ''
      this.dataEndTime = ''
      this.dataCamera = ''
    },
  },
  created() {
    this.video_cdn=process.env.VUE_APP_VIDEOS_CDN_LINK
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }

}

.picker {
  width: 175px;
}
</style>
